export const bySchemeTypeAndCoverLevel = (schemes) => {
  return schemes?.reduce((carry, scheme) => {
    const schemeType = scheme.attributes.scheme_type;
    const coverLevel = scheme.attributes.cover_level;

    if (!carry[schemeType]) {
      carry[schemeType] = {
        [coverLevel]: [scheme],
      };

      return carry;
    }
    const existing = carry[schemeType]?.[coverLevel];
    if (existing) {
      existing.push(scheme);
      carry[schemeType] = {
        ...carry[schemeType],
        [coverLevel]: existing,
      };
      return carry;
    }
    carry[schemeType] = {
      ...carry[schemeType],
      [coverLevel]: [scheme],
    };
    return carry;
  }, {});
};

export const bySchemeType = (schemes, isSchemeGroup) => {
  return schemes?.reduce((carry, scheme) => {
    const schemeType = isSchemeGroup
      ? scheme.attributes.group_key
      : scheme.attributes.scheme_type;
    if (!carry[schemeType]) {
      carry[schemeType] = [scheme];
      return carry;
    }
    carry[schemeType].push(scheme);
    return carry;
  }, {});
};

//
// export const schemeGroupsByGroupey = (schemes) => {
//
//
//   return schemes?.reduce((carry, scheme) => {
//
//     const schemeType = scheme.attributes.group_key;
//
//
//     if (!carry[schemeType]) {
//
//       carry[schemeType] = [scheme]
//
//       return carry;
//     }
//     const existing = carry[schemeType];
//     existing.push(scheme);
//
//     carry[schemeType] = existing;
//     return carry;
//
//   }, {});
// };
